import { useTranslation } from 'react-i18next';
import { type SyncState, useSyncStatus } from '../hooks/useSyncStatus';

const CHIP_STYLES: Record<SyncState, string> = {
  synced: 'bg-emerald-500/15 text-emerald-300 ring-emerald-500/30',
  pending: 'bg-amber-500/15 text-amber-300 ring-amber-500/30',
  failed: 'bg-red-500/15 text-red-300 ring-red-500/30',
  offline: 'bg-slate-500/15 text-slate-300 ring-slate-500/30',
};

const DOT_STYLES: Record<SyncState, string> = {
  synced: 'bg-emerald-400',
  pending: 'bg-amber-400 animate-pulse',
  failed: 'bg-red-400',
  offline: 'bg-slate-400',
};

/** Always visible, per CLAUDE.md — staff must never have to guess whether work saved. */
export function SyncStatusChip() {
  const { t } = useTranslation();
  const { state, pendingCount } = useSyncStatus();

  const label =
    state === 'pending' ? t('sync.pending', { count: pendingCount }) : t(`sync.${state}`);

  return (
    <span
      role="status"
      aria-live="polite"
      className={`inline-flex items-center gap-2 rounded-full px-3 py-1.5 text-sm font-medium ring-1 ${CHIP_STYLES[state]}`}
    >
      <span className={`size-2 rounded-full ${DOT_STYLES[state]}`} aria-hidden="true" />
      {label}
    </span>
  );
}
